import {Button, Card, Input, List, Space, Table, Typography} from "antd";
import {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {t} from "i18next";
import SimpleLayout from "../../core/components/layout/SimpleLayout";
import ApiService from "../../core/service/ApiService";
import {useUser} from "../../core/context/UserContext";

export default function RoleList()
{
    const history = useHistory();
    const [roles, setRoles] = useState([]);
    const [filteredData, setFilteredData] = useState([])
    const {firmSettings} = useUser();

    const getRoles = async () => {
        const res = await ApiService.Role.GetRoleList();

        if(res.success)
        {
            setRoles(res.data);
        }
    }

    useEffect(() => {
        getRoles()
    }, [])

    useEffect(() => {
        setFilteredData(roles)
    }, [roles])

    const renderAction = (row) => {
        return (
            <Space>
                <a key="edit" onClick={() => history.push(`/app/system/roles/edit/${row.id}`)}>{t('Edit')}</a>
            </Space>
        )
    }

    return (
        <SimpleLayout fullWidth={true}>
            <Card>
                <Space style={{marginBottom: 16}}>
                    <Button size={'small'} onClick={() => {history.push(`/app/system/roles/create`)}} type={'primary'}>{t('New')}</Button>
                    <Button size={'small'} onClick={getRoles}>{t('Refresh')}</Button>
                    <Input
                        size={'small'}
                        placeholder={t('Search')}
                        onChange={(e) => {
                            if(!e.target.value)
                            {
                                setFilteredData(roles);
                                return
                            }
                            setFilteredData(roles.filter(x => x.name.toLocaleUpperCase(firmSettings?.locale).includes(e.target.value.toLocaleUpperCase(firmSettings?.locale))))
                        }}
                    />
                </Space>
                <Table
                    size={'small'}
                    dataSource={filteredData}
                    pagination={false}
                    columns={[
                        {key: 'name', dataIndex: 'name', title: t('Name')},
                        {key: '#', dataIndex: '#', title: '#', render: (text, row) => renderAction(row)},
                    ]}
                />
            </Card>
        </SimpleLayout>
    )
}
